var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0682 7.01692C15.0682 8.66374 13.6742 10.1322 12 10.1322C10.3258 10.1322 8.93182 8.66374 8.93182 7.01692C8.93182 5.33421 10.3598 3.75726 12 3.75726C13.6402 3.75726 15.0682 5.33421 15.0682 7.01692ZM20.25 16.7851C20.25 17.5989 19.7954 18.4334 18.5056 19.1057C17.191 19.7909 15.0781 20.2574 12 20.2574C8.92186 20.2574 6.80897 19.7909 5.49439 19.1057C4.20459 18.4334 3.75 17.5989 3.75 16.7851C3.75 16.0816 4.38661 15.2141 5.95458 14.4785C7.46298 13.7709 9.59955 13.3129 12 13.3129C14.4005 13.3129 16.537 13.7709 18.0454 14.4785C19.6134 15.2141 20.25 16.0816 20.25 16.7851Z",
    stroke: "#8F9BBA",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile03);
export default __webpack_public_path__ + "static/media/user-profile-03.f697a8fc26c8516f1b0590f8770c6af8.svg";
export { ForwardRef as ReactComponent };